import React from 'react';

/** Persistent Pathfinder attribution shown in every page footer. */
export const PoweredByPathfinder: React.FC<{ className?: string }> = ({ className }) => (
  <span className={className}>
    <strong className="font-bold">Powered by Pathfinder</strong>
    ™ — Patent Pending, Soulax Inc.
  </span>
);

export default PoweredByPathfinder;
